<div fxLayout="row" fxLayoutAlign="center" style="margin:20px">
    <h2>{{"Ajouter votre Signature"}}</h2>
</div>
<div fxLayout="row" fxLayoutAlign="center">
    <button mat-flat-button color="warn" style="margin:15px" (click)="effacer()">Effacer</button>
    <button mat-flat-button color="primary" style="margin:15px" (click)="voirContrat()"> <mat-icon>receipt_long</mat-icon> Visualiser votre contrat </button>
</div>
<div fxLayout="row" fxLayoutAlign="center">   
    <signature-pad #signature [options]="signaturePadOptions" (drawStart)="drawStart($event)" (drawEnd)="drawComplete($event)"></signature-pad>
</div>
<div fxLayout="row" fxLayoutAlign="center">
    <h6>{{"Cette signature servira a établir votre contrat !!!"}}</h6>
</div>
<div fxLayout="row" fxLayoutAlign="center center">
    <button mat-flat-button color="warn" style="margin:15px" (click)="effacer()">Annuler</button>
    <button mat-flat-button color="primary" style="margin:15px" (click)="saveSignature()">Enregister</button>
</div>